import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Tabs,
  Tab,
  Grid,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import HelpCard from './HelpCard';
import { helpTopics } from './data/helpTopics';
import { useHistory } from 'react-router-dom';
import { ReactComponent as HelpIllustration } from './img/help-illustration-transparent_small.svg';

export default function HelpCenter() {
  const [tab, setTab] = useState(0);
  const [search, setSearch] = useState('');
  const theme = useTheme();
  const history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const tabLabels = ['Komma igång', 'Ämnen', 'Videohandledningar', 'Support'];

  const filtered = helpTopics[tab]?.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase()) ||
    item.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      {/* Toppsektion med sökfält och illustration */}
      <Box sx={{ backgroundColor: '#fff', px: 1, py: 2 }}>
        <Box
          sx={{
            maxWidth: '1400px',
            mx: 'auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: 2,
          }}
        >

          <Box sx={{ textAlign: isMobile ? 'center' : 'left' }}>
            <Typography variant="h4" sx={{ fontWeight: 400 }}>
              Hej, hur kan vi hjälpa dig?
            </Typography>
            <Box
              sx={{
                position: 'relative',
                maxWidth: 600,
                mt: 1,
                mx: isMobile ? 'auto' : 0,
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Sök i hjälpen..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  sx: {
                    borderRadius: '6px',
                    backgroundColor: '#fff',
                  },
                  endAdornment: (
                    <Box
                      sx={{
                        position: 'absolute',
                        right: 12,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        color: '#999',
                        fontSize: 20,
                      }}
                    >
                      <i className="nc-icon nc-zoom-split" />
                    </Box>
                  ),
                }}
                sx={{
                  input: {
                    color: '#333',
                    '&::placeholder': {
                      color: '#666',
                      opacity: 1,
                    },
                  },
                }}
              />
            </Box>
          </Box>

          {/* Illustration till höger */}
          <Box
            sx={{
              width: isMobile ? '60%' : 160,
              height: 'auto',
              mt: isMobile ? 0.5 : 1,
              ml: isMobile ? 0 : 2,
              '& svg': {
                width: '100%',
                height: 'auto',
                display: 'block',
              },
            }}
          >
            <HelpIllustration />
          </Box>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ mx: 'auto' }}>
        <Tabs
          value={tab}
          onChange={(e, newValue) => {
            if (tabLabels[newValue] === 'Ämnen') {
              history.push('/topics');
            } else {
              setTab(newValue);
            }
          }}
          centered
          textColor="primary"
          indicatorColor="primary"
          sx={{
            minHeight: 32,
            height: 32,
            backgroundColor: '#ffffff',
            '.MuiTabs-indicator': {
              backgroundColor: theme.palette.primary.main,
              height: '3px',
            },
          }}
        >
          {tabLabels.map((label, index) => (
            <Tab
              key={index}
              label={label}
              sx={{
                minHeight: 28,
                padding: '6px 12px',
                textTransform: 'none',
                fontWeight: 500,
                color: '#555',
                '&.Mui-selected': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Kort */}
      <Box sx={{ maxWidth: '1400px', mx: 'auto', px: { xs: 2, sm: 3 }, mt: 4 }}>
        <Grid container spacing={2}>
          {filtered?.map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.title} sx={{ display: 'flex' }}>
              <HelpCard
                {...item}
                onClick={() => {
                  if (item.linkText?.toLowerCase().includes('videohandledningar')) {
                    history.push('/videopage');
                  }
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
